/* eslint-disable camelcase */
import * as couponsSetting from '../services/couponsSetting';
import { splitByUnknownSeparators } from '@/utils/comUtil';
export default {
  namespace: 'couponsSetting',

  state: {
    step: 0,
    stepOneData: {
      title: '', //优惠券名称
      subTitle: '', //优惠券副标题
      comment: '', //优惠券备注
      quantity: null, //发放总量
      couponUsingThreshold: false, //使用门槛，在保存的时候过滤掉
      transactionMinimum: 0, //门槛满减金额
      discountAmount: '', //优惠减免
      couponGetCheckbox: true,
      validBegin: 0, //领券生效当日0次日1
      validDays: '', //领券后多少天内生效
      memberLimit: true, //领取人限制，不限制0，会员1
      isLimitMaxCoupons: true, //是否限领
      maxCouponsPerUser: '99', //限领次数
      canShare: false, //分享设置
      transferable: false, //转增设置
      isOver: true, //是否可以叠加使用
      isMemberDiscount: true, //0.不与会员折扣同享1.与会员折扣同享
      isActivityOver: true, //0.不与店铺促销同享1.与店铺促销同享
      isNonPositive: true, //0.不与非正价商品同享 1.与非正价商品同享
      isStaff: false, //卡券归属 0:不是员工券 1:员工券
      isPoint: true, //0.不能消耗 1.可以消耗 满减券折扣券专属是否消耗积分
      isRank: true, //0.不能升级 1.可以升级 满减券折扣券专属是否升级
      goodsNum: 0, //限制订单内商品件数
      description: '', //使用说明
      usedType: [], //适用渠道
      stores: [], //适用门店选中的json数据
      invertStores: [], //不适用门店选中的json数据
      isAllStore: '1', //适用门店选择
      isAllCompany: true, //指定适用公司选择
      isAllGoods: '1', //适用商品选择
      goods: [], //适用商品选中的json数据
      goodsProduct: [], //适用商品选中的json数据
      goodsSeries: [], //适用商品选中的json数据
      goodsStyles: [],
      goodsGoods: [],
      goodsSeason: [], //适用商品选中的json数据
      goodsSubclass: [], //适用商品选中的json数据
      goodsDesign: [], //款式选中的json数据
      goodsCategory: [], //适用商品选中的json数据
      invertGoods: [], //不适用商品选中的json数据
      goodsProductNo: [], //不适用商品选中的json数据
      goodsSeriesNo: [], //不适用商品选中的json数据
      goodsStylesNo: [],
      goodsGoodsNo: [],
      goodsSeasonNo: [], //不适用商品选中的json数据
      goodsSubclassNo: [], //不适用商品选中的json数据
      goodsDesignNo: [], //不适用款式选中的json数据
      goodsCategoryNo: [], //不适用商品选中的json数据
      templateId: '', //模板选择
      goodsName: '', //适用商品范围
      companies: [], //适用公司
      beginTime: null,
      endTime: null,
      type: '',
      channelType: 1,
      gift: '', //商品描述
      discountPercent: 0, //折扣比例
      noUseStory: false, //不可用门店
      useStory: false, //不可用门店
      noUseProduct: false, //不可用商品
      useProduct: false, //可用商品
      isSend: false,
      sendStartDate: null,
      sendEndDate: null,
      isExpire: false,
      expireStartDate: null,
      expireEndDate: null,
      thirdFilePath: null,
    },
    storesList: [],
    productsList: [],
    storeName: '', //门店名称
    storeCode: '', //门店Code
    storeStatus: '', //门店状态
    storeType: '', //门店类型
    storesPageSize: 10, //每页展示10条
    storesTotal: 0, //门店总条数
    storesPageNum: 1, //当前分页
    companyList: [], //公司列表
    productsPageSize: 10, //每页展示
    productsTotal: null, //产品总条数
    productsPageNum: 1, //产品列表
    productsName: '', //产品名称
    couponTemplateList: [],
    productsListSeries: [], //系列列表
    productsListStyles: [],
    productsListGoods: [],
    productsPageSizeSeries: 10, //每页展示
    productsPageSizeStyles: 10,
    productsPageSizeGoods: 10,
    productsTotalSeries: null, //产品总条数
    productsTotalStyles: null,
    productsTotalGoods: null,
    productsPageNumSeries: 1, //产品列表
    productsPageNumStyles: 1, //款号列表
    productsPageNumGoods: 1,
    productsNameSeries: '', //系列名称
    productsNameStyles: '', //款号名称
    productsListSeason: [], //季节列表
    productsPageSizeSeason: 10, //每页展示
    productsTotalSeason: null, //产品总条数
    productsPageNumSeason: 1, //产品列表
    productsNameSeason: '', //系列名称
    productsListSubclass: [], //季节列表
    productsPageSizeSubclass: 10, //每页展示
    productsTotalSubclass: null, //产品总条数
    productsPageNumSubclass: 1, //产品列表
    productsNameSubclass: '', //种类名称
    productsListCategory: [], //季节列表
    productsPageSizeCategory: 10, //每页展示
    productsTotalCategory: null, //产品总条数
    productsPageNumCategory: 1, //产品列表
    productsNameCategory: '', //类别名称
    productsNameDesign: '', //款式名称
    productsListDesign: [], //款式列表
    productsPageSizeDesign: 10, //每页展示
    productsPageNumDesign: 1, //产品列表
    productsTotalDesign: null, //款式总条数
  },

  effects: {
    *nextStep({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          step: value,
        },
      });
    },
    *resetForm({ payload: { value }, callback }, { put, select }) {
      const oldV = yield select((state) => state.couponsSetting[value.key]);
      yield put({
        type: 'save',
        payload: {
          [value.key]: { ...oldV, ...value[value.key] },
          step: value.step,
        },
      });
      const newV = yield select((state) => state.couponsSetting.stepOneData);
      callback && callback(newV);
    },
    // eslint-disable-next-line no-unused-vars
    *getStores({ payload: { value } }, { put, call }) {
      const { type, code, ...params } = value;
      params.storeTypeList = type ? [type] : null;
      console.log({ params, code });
      params.storeNoList = code ? splitByUnknownSeparators(code) : null;

      const response = yield call(couponsSetting.getStores, params);
      yield put({
        type: 'save',
        payload: {
          storesList: response.data.data,
          // storesPageSize: response.data.pageSize,//分页大小，10、50
          storesTotal: response.data.total, //总条数
          // storesPageNum: response.data.pageNum, //当前分页
        },
      });
    },
    // eslint-disable-next-line no-unused-vars
    *getProducts({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getProducts, value);
      yield put({
        type: 'save',
        payload: {
          productsList: response.data.data,
          productsPageSize: response.data.pageSize, //分页大小，10、50
          productsTotal: response.data.total, //总条数
          productsPageNum: response.data.pageNum, //当前分页
        },
      });
    },
    // eslint-disable-next-line no-unused-vars
    *getProductsSeries({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getNewProductsSeries, value);
      yield put({
        type: 'save',
        payload: {
          productsListSeries: response.data.data,
          productsPageSizeSeries: response.data.pageSize, //分页大小，10、50
          productsTotalSeries: response.data.total, //总条数
          productsPageNumSeries: response.data.pageNum, //当前分页
        },
      });
    },
    // 获取款号
    *getProductsStyle({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getNewProductsStyles, value);
      yield put({
        type: 'save',
        payload: {
          productsListStyles: response.data.data,
          productsPageSizeStyles: response.data.pageSize, //分页大小，10、50
          productsTotalStyles: response.data.total, //总条数
          productsPageNumStyles: response.data.pageNum, //当前分页
        },
      });
    },
    // 获取货号
    *getProductsGoods({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getNewProductsGoods, value);
      yield put({
        type: 'save',
        payload: {
          productsListGoods: response.data.data,
          productsPageSizeGoods: response.data.pageSize, //分页大小，10、50
          productsTotalGoods: response.data.total, //总条数
          productsPageNumGoods: response.data.pageNum, //当前分页
        },
      });
    },
    // eslint-disable-next-line no-unused-vars
    *getProductsSeason({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getProductsSeries, value);
      yield put({
        type: 'save',
        payload: {
          productsListSeason: response.data.data,
          productsPageSizeSeason: response.data.pageSize, //分页大小，10、50
          productsTotalSeason: response.data.total, //总条数
          productsPageNumSeason: response.data.pageNum, //当前分页
        },
      });
    },
    // eslint-disable-next-line no-unused-vars
    *getProductsCategory({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getProductsSeries, value);
      yield put({
        type: 'save',
        payload: {
          productsListCategory: response.data.data,
          productsPageSizeCategory: response.data.pageSize, //分页大小，10、50
          productsTotalCategory: response.data.total, //总条数
          productsPageNumCategory: response.data.pageNum, //当前分页
        },
      });
    },
    // eslint-disable-next-line no-unused-vars
    *getProductsSubclass({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getProductsSeries, value);
      yield put({
        type: 'save',
        payload: {
          productsListSubclass: response.data.data,
          productsPageSizeSubclass: response.data.pageSize, //分页大小，10、50
          productsTotalSubclass: response.data.total, //总条数
          productsPageNumSubclass: response.data.pageNum, //当前分页
        },
      });
    },
    // 获取款式-----
    *getProductsDesign({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getProductsSeries, value);
      yield put({
        type: 'save',
        payload: {
          productsListDesign: response.data.data,
          productsPageSizeDesign: response.data.pageSize, //分页大小，10、50
          productsTotalDesign: response.data.total, //总条数
          productsPageNumDesign: response.data.pageNum, //当前分页
        },
      });
    },
    *getCompany({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getCompany, value);
      let cList = [];
      if (response.data.length > 0) {
        cList = response.data.reduce(function (prev, cur) {
          return [...prev, ...cur.subCompany];
        }, []);
      }
      yield put({
        type: 'save',
        payload: {
          companyList: cList,
        },
      });
    },
    *getQueryTemplateList({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.getQueryTemplateList, value);
      yield put({
        type: 'save',
        payload: {
          couponTemplateList: response.data,
        },
      });
    },
    *setStoresPage({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          storesPageNum: value.pageNum,
          storesPageSize: value.pageSize,
        },
      });
    },
    *setProductsPage({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsPageNum: value.pageNum,
          productsPageSize: value.pageSize,
        },
      });
    },
    *setProductsPageSeries({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsPageNumSeries: value.pageNum,
          productsPageSizeSeries: value.pageSize,
        },
      });
    },
    // 款号
    *setProductsPageStyles({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsPageNumStyles: value.pageNum,
          productsPageSizeStyles: value.pageSize,
        },
      });
    },
    // 货号
    *setProductsPageGoods({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsPageNumGoods: value.pageNum,
          productsPageSizeGoods: value.pageSize,
        },
      });
    },

    *setProductsPageSeason({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsPageNumSeason: value.pageNum,
          productsPageSizeSeason: value.pageSize,
        },
      });
    },
    *setProductsPageSubclass({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsPageNumSubclass: value.pageNum,
          productsPageSizeSubclass: value.pageSize,
        },
      });
    },
    *setProductsPageDesign({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsPageNumDesign: value.pageNum,
          productsPageSizeDesign: value.pageSize,
        },
      });
    },
    *setProductsPageCategory({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsPageNumCategory: value.pageNum,
          productsPageSizeCategory: value.pageSize,
        },
      });
    },
    *searchStores({ payload: { value } }, { put }) {
      console.log('-----', value);
      yield put({
        type: 'save',
        payload: {
          storeName: value?.storeName || '',
          storeCode: value?.storeCode || '',
          storeStatus: value?.storeStatus || '',
          storeType: value?.storeType || '',
          storesPageNum: value.pageNum,
          storesPageSize: value.pageSize,
        },
      });
    },
    *searchProducts({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsName: value.productsName,
        },
      });
    },
    *searchProductsSeries({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsNameSeries: value.productsNameSeries,
        },
      });
    },
    // 搜索款号
    *searchProductsStyles({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsNameStyles: value.productsNameStyles,
        },
      });
    },
    *searchProductsGoods({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsNameGoods: value.productsNameGoods,
        },
      });
    },
    *searchProductsSeason({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsNameSeason: value.productsNameSeason,
        },
      });
    },
    *searchProductsSubclass({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsNameSubclass: value.productsNameSubclass,
        },
      });
    },
    *searchProductsDesign({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsNameDesign: value.productsNameDesign,
        },
      });
    },
    *searchProductsCategory({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          productsNameCategory: value.productsNameCategory,
        },
      });
    },
    *addCoupon({ payload: { value }, callback }, { call }) {
      yield call(couponsSetting.addCoupon, {
        ...value.stepOneData,
      });
      callback('200');
    },
    *updateCoupon({ payload: { value }, callback }, { call }) {
      yield call(couponsSetting.updateCoupon, {
        ...value.stepOneData,
      });
      callback('200');
    },
    *initForm({ payload: { value } }, { put }) {
      yield put({
        type: 'save',
        payload: value,
      });
    },
    *initEachForm({ payload: { value } }, { put }) {
      yield put({
        type: 'saveEach',
        payload: {
          stepOneData: {
            ...value,
          },
        },
      });
    },
    // eslint-disable-next-line no-unused-vars
    *couponInitData({ payload: { value } }, { put, call }) {
      const response = yield call(couponsSetting.couponInitData, value);
      if (response.code === 0) {
        let stepOneData = {};
        const data = response.data;
        stepOneData.beginTime = data.beginTime;
        stepOneData.canShare = data.canShare;
        stepOneData.channelType = data.channelType;
        stepOneData.comment = data.comment;

        stepOneData.description = data.description;
        stepOneData.discountAmount = data.discountAmount;
        stepOneData.discountPercent = data.discountPercent;

        stepOneData.description = data.description;
        stepOneData.discountAmount = data.discountAmount;
        stepOneData.endTime = data.endTime;
        //可用商品
        stepOneData.goods =
          data.goods && Array.isArray(data.goods) ? data.goods : [];
        stepOneData.goodsName = data.goodsName;
        stepOneData.goodsNum = data.goodsNum;
        stepOneData.id = data.id;
        stepOneData.goodsProduct =
          data.goods && Array.isArray(data.goods)
            ? data.goods.filter((item) => item.addType === null)
            : [];
        stepOneData.goodsSeries =
          data.goods && Array.isArray(data.goods)
            ? data.goods.filter((item) => item.addType === 'SERIES')
            : [];
        stepOneData.goodsStyles =
          data.goods && Array.isArray(data.goods)
            ? data.goods.filter((item) => item.addType === 'SPU')
            : [];
        stepOneData.goodsGoods =
          data.goods && Array.isArray(data.goods)
            ? data.goods.filter((item) => item.addType === 'MATERIAL_CODE')
            : [];
        stepOneData.goodsSeason =
          data.goods && Array.isArray(data.goods)
            ? data.goods.filter((item) => item.addType === 'SEASON')
            : [];
        stepOneData.goodsSubclass =
          data.goods && Array.isArray(data.goods)
            ? data.goods.filter((item) => item.addType === 'SUBCLASS')
            : [];
        stepOneData.goodsDesign =
          data.goods && Array.isArray(data.goods)
            ? data.goods.filter((item) => item.addType === 'STYLE')
            : [];
        stepOneData.goodsCategory =
          data.goods && Array.isArray(data.goods)
            ? data.goods.filter((item) => item.addType === 'GENERAL_CATEGORY')
            : [];
        //不可用商品
        stepOneData.invertGoods =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods
            : [];
        stepOneData.goodsProductNo =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods.filter((item) => item.addType === null)
            : [];
        stepOneData.goodsSeriesNo =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods.filter((item) => item.addType === 'SERIES')
            : [];
        // 款式
        stepOneData.goodsStylesNo =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods.filter((item) => item.addType === 'SPU')
            : [];
        // 货号
        stepOneData.goodsGoodsNo =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods.filter(
                (item) => item.addType === 'MATERIAL_CODE',
              )
            : [];
        stepOneData.goodsSeasonNo =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods.filter((item) => item.addType === 'SEASON')
            : [];
        stepOneData.goodsSubclassNo =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods.filter((item) => item.addType === 'SUBCLASS')
            : [];
        stepOneData.goodsDesignNo =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods.filter((item) => item.addType === 'STYLE')
            : [];
        stepOneData.goodsCategoryNo =
          data.invertGoods && Array.isArray(data.invertGoods)
            ? data.invertGoods.filter(
                (item) => item.addType === 'GENERAL_CATEGORY',
              )
            : [];

        stepOneData.isActivityOver = data.isActivityOver;
        stepOneData.isAllCompany = data.isAllCompany;
        stepOneData.isAllGoods = String(data.isAllGoods);
        stepOneData.isAllStore = String(data.isAllStore);

        stepOneData.isLimitMaxCoupons = data.isLimitMaxCoupons;
        stepOneData.isMemberDiscount = data.isMemberDiscount;
        stepOneData.isNonPositive = data.isNonPositive;
        stepOneData.isOver = data.isOver;

        stepOneData.isPoint = data.isPoint;
        stepOneData.isRank = data.isRank;
        stepOneData.isStaff = data.isStaff;
        stepOneData.maxCouponsPerUser = data.maxCouponsPerUser;

        stepOneData.memberLimit = data.memberLimit;
        stepOneData.quantity = data.quantity;
        stepOneData.stores = data.stores || [];
        stepOneData.invertStores = data.invertStores || [];
        stepOneData.subTitle = data.subTitle;

        stepOneData.templateId = data.templateId;
        stepOneData.title = data.title;
        stepOneData.thirdFilePath = data.thirdFilePath
          ? JSON.stringify([
              {
                url: data.thirdFilePath,
                id: 1,
                fileName: data.thirdFilePath.split('/').pop(),
              },
            ])
          : '';
        stepOneData.transactionMinimum = data.transactionMinimum;
        stepOneData.transferable = data.transferable;

        stepOneData.usedType = data.usedType ? data.usedType : [];
        stepOneData.validBegin = data.validBegin;
        stepOneData.validDays = data.validDays;
        stepOneData.companies = data.companies ? data.companies : [];
        stepOneData.type = data.type;
        stepOneData.discountPercent = data.discountPercent
          ? data.discountPercent
          : 0;
        stepOneData.gift = data.gift;
        stepOneData.noUseStory =
          data.invertStores && data.invertStores.length > 0;
        stepOneData.useStory = data.stores && data.stores.length > 0;
        stepOneData.noUseProduct =
          data.invertGoods && data.invertGoods.length > 0;
        stepOneData.useProduct = data.goods && data.goods.length > 0;
        stepOneData.isSend = data.isSend;
        stepOneData.sendStartDate = data.sendStartDate;
        stepOneData.sendEndDate = data.sendEndDate;
        stepOneData.isExpire = data.isExpire;
        stepOneData.expireStartDate = data.expireStartDate;
        stepOneData.expireEndDate = data.expireEndDate;

        yield put({
          type: 'save',
          payload: {
            stepOneData,
          },
        });
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
    saveEach(state, action) {
      const s = { ...state.stepOneData, ...action.payload.stepOneData };
      return { ...state, stepOneData: { ...s } };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          [
            '/coupon/coupon_list/cash',
            '/coupon/coupon_list/discount',
            '/coupon/coupon_list/full-discount',
            '/coupon/coupon_list/exchange',
            '/coupon/coupon_list/three-way-coupon',
            '/marketing/scene/festival',
            '/marketing/luck_draw_view/luck_draw_view_setting_edit',
            '/marketing/luck_draw_view/luck_draw_view_setting_add',
            '/marketing/luck_draw_view/luck_draw_view_setting_detail',
            '/marketing/activity',
            '/marketing/luck_draw_view/qr_code',
            '/marketing/app_activity_fission/qr_code',
            '/integral/goods_shelf_management/qr_code',
            '/marketing/appoint_activity/qr_code',
            '/marketing/member_benefit_voucher/qr_code',
            '/marketing/registered_gift/add',
            '/marketing/registered_gift/edit',
            '/marketing/registered_gift/detail',
            '/miniapps/qr_code/qr_code_edit',
            '/miniapps/qr_code/qr_code_add',
            '/miniapps/qr_code/qr_code_detail',
          ].includes(props.pathname)
        ) {
          const qType = props.query?.type;
          const type =
            qType === '1'
              ? 'DISCOUNT_COUPON'
              : qType === '2'
              ? 'CASH_COUPON'
              : qType === '3'
              ? 'FULL_DISCOUNT_COUPON'
              : qType === '4'
              ? 'EXCHANGE_COUPON'
              : qType === '8'
              ? 'EXTERNAL_COUPON'
              : '';
          dispatch({
            type: 'initForm',
            payload: {
              value: {
                step: 0,
                stepOneData: {
                  title: '', //优惠券名称
                  subTitle: '', //优惠券副标题
                  comment: '', //优惠券备注
                  quantity: null, //发放总量
                  couponUsingThreshold: false, //使用门槛，在保存的时候过滤掉
                  transactionMinimum: 0, //门槛满减金额
                  discountAmount: '', //优惠减免
                  couponGetCheckbox: true,
                  validBegin: 0, //领券生效当日0次日1
                  validDays: '', //领券后多少天内生效
                  memberLimit: true, //领取人限制，不限制0，会员1
                  isLimitMaxCoupons: true, //是否限领
                  maxCouponsPerUser: '99', //限领次数
                  canShare: false, //分享设置
                  transferable: false, //转增设置
                  isOver: true, //是否可以叠加使用
                  isMemberDiscount: true, //0.不与会员折扣同享1.与会员折扣同享
                  isActivityOver: true, //0.不与店铺促销同享1.与店铺促销同享
                  isNonPositive: true, //0.不与非正价商品同享 1.与非正价商品同享
                  isStaff: false, //卡券归属 0:不是员工券 1:员工券
                  isPoint: true, //0.不能消耗 1.可以消耗 满减券折扣券专属是否消耗积分
                  isRank: true, //0.不能升级 1.可以升级 满减券折扣券专属是否升级
                  goodsNum: 0, //限制订单内商品件数
                  description: '', //使用说明
                  usedType: [], //适用渠道
                  stores: [], //适用门店选中的json数据
                  invertStores: [], //不适用门店选中的json数据
                  isAllStore: '1', //适用门店选择
                  isAllCompany: true, //指定适用公司选择
                  isAllGoods: '1', //适用商品选择
                  goods: [], //适用商品选中的全部json数据
                  goodsProduct: [], //适用商品选中的json数据
                  goodsSeries: [], //适用商品选中的json数据
                  goodsStylesNo: [],
                  goodsGoodsNo: [],
                  goodsStyles: [],
                  goodsGoods: [],
                  goodsSeason: [], //适用商品选中的json数据
                  goodsSubclass: [], //适用商品选中的json数据
                  goodsDesign: [], //适用款式选中的json数据
                  goodsCategory: [], //适用商品选中的json数据
                  invertGoods: [], //不适用商品选中的json数据
                  goodsProductNo: [], //不适用商品选中的json数据
                  goodsSeriesNo: [], //不适用商品选中的json数据
                  goodsSeasonNo: [], //不适用商品选中的json数据
                  goodsSubclassNo: [], //不适用商品选中的json数据
                  goodsDesignNo: [], //不适用款式选中的json数据
                  goodsCategoryNo: [], //不适用商品选中的json数据
                  templateId: '', //模板选择
                  goodsName: '', //适用商品范围
                  companies: [], //适用公司
                  beginTime: null,
                  endTime: null,
                  type,
                  channelType: 1,
                  discountPercent: 0, //折扣比例
                  gift: '', //商品描述
                  noUseStory: false, //不可用门店
                  useStory: false, //可用门店
                  noUseProduct: false, //不可用商品
                  useProduct: false, //可用商品
                  isSend: false,
                  sendStartDate: null,
                  sendEndDate: null,
                  isExpire: false,
                  expireStartDate: null,
                  expireEndDate: null,
                  thirdFilePath: null,
                },
                storesList: [],
                productsList: [],
                storeName: '', //门店名称
                storeCode: '', //门店Code
                storeStatus: '', //门店状态
                storeType: '', //门店类型
                storesPageSize: 10, //每页展示10条
                storesTotal: 0, //门店总条数
                storesPageNum: 1, //当前分页
                companyList: [], //公司列表
                productsPageSize: 10, //每页展示
                productsTotal: null, //产品总条数
                productsPageNum: 1, //产品列表
                productsName: '', //产品名称

                couponTemplateList: [],
                productsListSeries: [], //系列列表
                productsListStyles: [],
                productsListGoods: [],
                productsPageSizeSeries: 10, //每页展示
                productsPageSizeStyles: 10,
                productsPageSizeGoods: 10,
                productsTotalSeries: null, //产品总条数
                productsTotalStyles: null,
                productsTotalGoods: null,
                productsPageNumSeries: 1, //产品列表
                productsPageNumStyles: 1,
                productsPageNumGoods: 1,
                productsNameSeries: '', //系列名称
                productsNameStyles: '', //款号名称
                productsListSeason: [], //季节列表
                productsPageSizeSeason: 10, //每页展示
                productsTotalSeason: null, //产品总条数
                productsPageNumSeason: 1, //产品列表
                productsNameSeason: '', //系列名称
                productsListSubclass: [], //季节列表
                productsPageSizeSubclass: 10, //每页展示
                productsTotalSubclass: null, //产品总条数
                productsPageNumSubclass: 1, //产品列表
                productsNameSubclass: '', //种类名称
                productsListCategory: [], //季节列表
                productsPageSizeCategory: 10, //每页展示
                productsTotalCategory: null, //产品总条数
                productsPageNumCategory: 1, //产品列表
                productsNameCategory: '', //类别名称
                productsListDesign: [], //季节列表
                productsPageSizeDesign: 10, //每页展示
                productsTotalDesign: null, //产品总条数
                productsPageNumDesign: 1, //产品列表
                productsNameDesign: '', //种类名称
              },
            },
          });
        }
      });
    },
  },
};
